import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import RivalsButton from "rivals/components/shared/Button";
import CustomButton from "rivals/components/shared/CustomButton";
import CloseIcon from "rivals/components/shared/Icons/Close";
import { DATE_MM_DD_YYYY } from "rivals/shared/constants";
import commonStyles from "rivals/styles/exports.module.scss";
import styles from "./index.module.scss";
import strings from "./strings";
import { OwnProps } from "./types";

const {
  earlierVersion,
  latest,
  philter,
  version: versionString,
  viewLatestVersion
} = strings;

const VersionHeader = ({
  onViewLatestVersion,
  version,
  latestVersion
}: OwnProps): JSX.Element | null => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    setShow(true);
  }, [version]);

  const handleCloseButtonClick = useCallback(() => {
    setShow(false);
  }, []);

  if (!show) {
    return null;
  }

  const { listId, updatedAt } = version;

  const isLatest = listId === latestVersion.listId;
  const date =
    updatedAt instanceof Date
      ? moment(updatedAt).format(DATE_MM_DD_YYYY)
      : updatedAt;

  const action = isLatest ? (
    <CustomButton
      ariaLabel="hide"
      className={styles.closeIconWrapper}
      icon={<CloseIcon fill={commonStyles.white} />}
      onClick={handleCloseButtonClick}
      philter={`${philter}-close`}
    />
  ) : (
    <RivalsButton
      buttonText={viewLatestVersion}
      className={styles.viewLatestVersionButton}
      data={`${philter}-view-latest-version`}
      onClick={onViewLatestVersion}
      size="small"
    />
  );

  return (
    <div className={styles.versionHeader}>
      <div className={styles.textWrapper}>
        {versionString}: {date}{" "}
        <span className={styles.versionStatus}>
          {isLatest ? latest : earlierVersion}
        </span>
      </div>
      <div className={styles.actionWrapper}>{action}</div>
    </div>
  );
};

export default VersionHeader;
